"use strict";

/**
 *
 * @param {String} url - absolute url to Piwik-script
 * @param {Function} onLoad
 * @param {function(Error|null)} onError
 * @returns {Node}
 */
Object.defineProperty(exports, "__esModule", {
    value: true
});
var getPiwikScript = function getPiwikScript(url, onLoad, onError) {
    var script = document.createElement("script");

    var _onLoad = function _onLoad() {
        onLoad();
        script.onload = script.onreadystatechange = null;
        script.onerror = null;
    };

    var _onError = function _onError() {
        onError(new URIError("Failed to load " + url + ".") || null);
        script.onload = script.onreadystatechange = null;
        script.onerror = null;
    };

    script.type = "text/javascript";
    script.src = url;
    script.defer = true;
    script.async = true;
    script.onload = script.onreadystatechange = _onLoad;
    script.onerror = _onError;

    return script;
};

exports["default"] = getPiwikScript;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/piwik-wrap/build/lib/getPiwikScript.js
 ** module id = ./node_modules/piwik-wrap/build/lib/getPiwikScript.js
 ** module chunks = 1
 **/